<template lang="html">
    <section class="aDemo">
        <Firework v-if="firework" :boxHeight="'100%'" :boxWidth="'100%'" />
        <div>
            <div>
                <div class="Vlt-grid">
                    <div class="Vlt-col Vlt-col--A-1of3">
                        <vlt-field>
                            <vue-phone-number-input color="#131415" :no-validator-state="false"
                                :default-country-code="nexmo.region" v-model="prettyNumber" @update="onUpdate" />
                        </vlt-field>
                        <vlt-button :class="(!connected && !connecting) ? 'glowbutton' : ''" v-if="!connected"
                            label="Connect" secondary app @click="connect" :disabled="(!isValid || connecting)" />
                        <vlt-button v-else label="Disconnect" secondary app @click="disconnect" />
                    </div>
                    <div class="Vlt-col Vlt-col--A-1of3 centered">
                        <vlt-button v-if="contestants[0].enrolled > 99" large label="Ask a Question" quaternary app
                            @click="ask" />
                        <div v-else class="Vlt-native-dropdown" style="margin-top:-60px;">
                            <select name="iSelect" id="iSelect" v-model="winner" @change="winnerChange">
                                <option value="300">300 Points to Win</option>
                                <option value="400">400 Points to Win</option>
                                <option value="500">500 Points to Win</option>
                                <option value="600">600 Points to Win</option>
                                <option value="700">700 Points to Win</option>
                                <option value="800">800 Points to Win</option>
                                <option value="900">900 Points to Win</option>
                                <option value="1000">1000 Points to Win</option>
                                <option value="500000">Keep Going Forever!</option>
                            </select>
                        </div>
                    </div>
                    <div class="Vlt-col Vlt-col--A-1of3">
                        <h3 style="color:LightSlateGrey;">
                            Voice Recognition by: <span style="color:green;">ValidSoft</span><br>
                            Transcription by: <span style="color:green">Speechmatics</span>
                            <div style="display: inline-block;height:30px;">
                                <select style="display: inline-block;height:25px;" v-model="frames"
                                    @change="paramChange">
                                    <option value="150">200 frames</option>
                                    <option value="200">200 frames</option>
                                    <option value="250">250 frames</option>
                                    <option value="300">300 frames</option>
                                    <option value="350">350 frames</option>
                                    <option value="400">400 frames</option>
                                    <option value="450">450 frames</option>
                                    <option value="500">500 frames</option>
                                </select>
                            </div>
                            <div style="display: inline-block;">
                                <select style="display: inline-block;height:25px;" v-model="delta"
                                    @change="paramChange">
                                    <option :value="0.0">No delta</option>
                                    <option :value="0.05">0.05 delta</option>
                                    <option :value="0.10">0.10 delta</option>
                                    <option :value="0.15">0.15 delta</option>
                                    <option :value="0.20">0.20 delta</option>
                                    <option :value="0.25">0.25 delta</option>
                                    <option :value="0.30">0.30 delta</option>
                                    <option :value="0.35">0.35 delta</option>
                                    <option :value="0.40">0.40 delta</option>
                                    <option :value="0.45">0.45 delta</option>
                                    <option :value="0.50">0.50 delta</option>
                                </select>
                            </div>
                            <vlt-button style="display: inline-block;" small v-if="nexmo.role == 'admin'"
                                label="Edit Questions" tertiary app @click="setQuestions" />
                        </h3>
                    </div>
                    <vlt-button v-if="false" label="Reset the Game" secondary app @click="reset" />
                </div>
            </div>
            <div class="Vlt-grid">
                <div class="Vlt-col" v-for="contestant in contestants">
                    <div style="font-size:12px" class="Vlt-card Vlt-card--scrollable ">
                        <h5 style="display: inline-block;">
                            <vlt-button :class="(contestant.enrolled < 0 && connected && glow) ? 'glowbutton' : ''"
                                v-if="contestant.enrolled < 0" style="display: inline-block;margin-left: 2em;"
                                :label="contestant.enrolled > 99 ? 'Re-Register' : 'Register'" secondary app
                                @click="enroll(contestant.id)" :disabled="(!connected)" />
                            <h3 style="display: inline-block;margin-left: 0em;">{{ contestant.name }}</h3>
                            <div v-if="contestant.enrolled > 99" style="display: inline-block;margin-left: 2em;">
                                <vlt-icon icon="thumbs-up" color="green" />
                                Voice Registered
                            </div>
                            <div v-else>
                                <vue-speedometer :height="180" :minValue="0" :maxValue="100"
                                    :value="contestant.enrolled < 0 ? 0 : contestant.enrolled"
                                    currentValueText="Voice Registration % : ${value}" />
                            </div>
                            <div class="Vlt-grid" v-if="contestant.score">
                                <div class="Vlt-col">
                                    <h4>Score: {{ contestant.score }}</h4>
                                </div>
                                <div class="Vlt-col">
                                    <h4>Right: {{ contestant.right }}</h4>
                                </div>
                            </div>
                            <div class="Vlt-table Vlt-table--short" data-sortable
                                style="padding-bottom: 1px;padding-top: 1px;">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Registration Text</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in contestant.text">
                                            <td>{{ item }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </h5>
                    </div>
                </div>
            </div>
            <vlt-modal class="Vlt-modal" message="Winner" title="We have a WINNER!" :canCancel="false"
                :visible="firework" @confirm="clearWinner">

                <h1 class="winner">{{ contestants[awinner].name }}</h1>
                <br><br><br>
                <h4> Won with {{ contestants[awinner].score }} points!</h4><img width="200"
                    src="static/img/trophy.gif" />'

            </vlt-modal>
            <vlt-modal class="Vlt-modal--large" message="Editing..." title="Add/Edit Questions" :canCancel="false"
                :visible="editing" @confirm="cancelEditing">
                <questions v-if="editing" :nexmo="nexmo" :questions="questions" :DEMO="DEMO" />
            </vlt-modal>
            <vlt-modal class="Vlt-modal--large" message="Loading Question..." :title="'' + points + ' Point Question:'"
                :canCancel="false" :visible="inQuestion" @confirm="cancelQuestion">
                <div class="Vlt-card Vlt-card--scrollable">
                    <h5 style="display: inline-block;">
                        <h3 style="color:gray">Repeat the question, then give the answer:</h3>
                        <h3 style="display: inline-block;margin-left: 0em; color:green;">{{ question }}</h3>
                    </h5>

                    <div v-if="result">
                        <p v-html="result"></p>
                    </div>
                    <div v-if="answerer >= 0 || result">
                        <h4 style="color:red">Identified: {{ (answerer >= 0) ? contestants[answerer].name : 'Keep talking...'
                            }}</h4>
                        <div v-if="answerer >= 0 && result" class="box">
                            <Firework :boxHeight="'100%'" :boxWidth="'100%'" />
                            <figure>
                                <m1>{{ contestants[answerer].name }} is correct!</m1>
                                <m1>{{ contestants[answerer].name }} is correct!</m1>
                                <m1>{{ contestants[answerer].name }} is correct!</m1>
                            </figure>
                        </div>
                    </div>
                    <div class="Vlt-table Vlt-table--short" data-sortable style="padding-bottom: 1px;">
                        <table>
                            <thead>
                                <tr>
                                    <th>Answers so far:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in answers">
                                    <td>{{ item }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="Vlt-modal__footer">
                    <vlt-button v-if="answerer >= 0 && !result.length" label="Let Someone Else Try!" secondary app
                        @click="reAsk" />
                    <div class="Vlt-grid">
                        <div class="Vlt-col  Vlt-col--A-1of3"></div>
                        <div class="Vlt-col  Vlt-col--A-1of3">
                            <vlt-button label="Next Question" secondary app @click="ask" />
                        </div>
                        <div class="Vlt-col  Vlt-col--A-1of3">
                            <div style="display: inline-block;height:30px;margin-top:13px;">
                                <select style="display: inline-block;height:25px;" v-model="frames"
                                    @change="paramChange">
                                    <option value="150">200 frames</option>
                                    <option value="200">200 frames</option>
                                    <option value="250">250 frames</option>
                                    <option value="300">300 frames</option>
                                    <option value="350">350 frames</option>
                                    <option value="400">400 frames</option>
                                    <option value="450">450 frames</option>
                                    <option value="500">500 frames</option>
                                </select>
                            </div>
                            <div style="display: inline-block;">
                                <select style="display: inline-block;height:25px;" v-model="delta"
                                    @change="paramChange">
                                    <option :value="0.00001">No delta</option>
                                    <option :value="0.05">0.05 delta</option>
                                    <option :value="0.10">0.10 delta</option>
                                    <option :value="0.15">0.15 delta</option>
                                    <option :value="0.20">0.20 delta</option>
                                    <option :value="0.25">0.25 delta</option>
                                    <option :value="0.30">0.30 delta</option>
                                    <option :value="0.35">0.35 delta</option>
                                    <option :value="0.40">0.40 delta</option>
                                    <option :value="0.45">0.45 delta</option>
                                    <option :value="0.50">0.50 delta</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </vlt-modal>
        </div>
    </section>
</template>

<script lang="js">
import axios from 'axios';
import {
    $HTTPDEMO,
    requestHandler
} from '../services/nidsService.js';
import {
    $NODEBASE
} from '../base';
import Firework from '../components/fireworks.vue';
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import {
    JSONView
} from "vue-json-component";
import questions from "./questions";
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltModal,
} from "@vonagevolta/vue";
import VueSpeedometer from "vue-speedometer";

export default {
    name: 'sampleDemo',
    data() {
        return {
            number: '',
            prettyNumber: '',
            numberStuff: {},
            fromNumber: '',
            isValid: false,
            connected: false,
            inQuestion: false,
            frames: 350,
            delta: 0.2,
            answers: [],
            answerer: -1,
            scored: false,
            DEMO: {},
            pusher: {},
            basic: [],
            standard: [],
            advanced: [],
            questions: [],
            firework: false,
            glow: true,
            winner: 500,
            awinner: 0,
            connecting: false,
            dev: false,
            editing: false,
            contestants: [{
                id: 0,
                name: "Player 1  ",
                enrolled: -1,
                score: 0,
                right: 0,
                text: [],
            },
            {
                id: 1,
                name: "Player 2  ",
                enrolled: -1,
                score: 0,
                right: 0,
                text: [],
            },
            {
                id: 2,
                name: "Player 3  ",
                enrolled: -1,
                score: 0,
                right: 0,
                text: [],
            },
            ],
            numContestants: 3,
            question: '',
            result: '',
            hint: '',
            points: 100,
        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        }
    },
    methods: {
        cancelEditing() {
            this.editing = false;
        },
        paramChange() {
            console.log("Params: Frames=" + this.frames + ", delta=" + this.delta);
            this.DEMO.post('params', {
                frames: this.frames,
                delta: this.delta,
            });
        },
        setQuestions() {
            this.DEMO.post('getQuestions', {}).then(request => {
                console.log("getQuestions results");
                console.log(request.data);
                this.questions = request.data;
                this.editing = true;
            });
        },
        winnerChange() {
            console.log("New points to win: " + this.winner);
        },
        connect() {
            this.DEMO.post('connect', {
                phone: this.number,
            }).then(request => {
                console.log("Demo connect result for  " + this.number);
                console.log(request.data);
                this.connecting = true;
            });
        },
        disconnect() {
            this.DEMO.post('disconnect', {}).then(request => {
                console.log("Demo disconnect result ", request.data);
                this.connecting = false;
                this.connected = false;
            });
        },
        ask() {
            this.DEMO.post('ask', {
                phone: this.number,
            }).then(request => {
                console.log("Demo Ask result");
                console.log(request.data);
                this.question = request.data.question;
                this.inQuestion = true;
                this.result = '';
                this.answers.length = 0;
                this.answerer = -1;
                this.scored = false;
                this.glow = false;
                if (request.data.hint) {
                    this.hint = request.data.hint;
                } else {
                    this.hint = '';
                }
                if (request.data.points) {
                    this.points = request.data.points;
                } else {
                    this.points = 100;
                }
            });
            this.firework = false;
        },
        reAsk() {
            this.DEMO.post('reask', {}).then(request => {
                this.inQuestion = true;
                this.result = '';
                this.answers.length = 0;
                this.answerer = -1;
                this.scored = false;
            });
        },
        reset() {
            this.DEMO.post('reset', {
                phone: this.number,
            }).then(request => {
                console.log("Demo reset result for  " + this.number);
                console.log(request.data);
            });
        },
        enroll(id) {
            console.log("Enrollment for id=" + id);
            this.contestants[id].name = "Player " + (id + 1);
            this.contestants[id].enrolled = 0;
            this.DEMO.post('enroll', {
                id: id,
            }).then(request => {
                console.log("Demo enrollment result for  " + this.number);
                console.log(request.data);
            });
        },
        register() {
            console.log("Registering the Demo Component with the associated backend");
            this.setupPusher();
            this.DEMO.post('register', {
                frames: this.frames,
                delta: this.delta,
            });
        },
        onUpdate(payload) {
            this.numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        clearWinner() {
            this.firework = false;
        },
        cancelQuestion() {
            this.inQuestion = false;
            this.firework = false;
            for (var index = 0; index < this.contestants.length; ++index) {
                if (this.contestants[index].score >= this.winner) {
                    this.aWinner(index, 0);
                    break;
                }
            }
        },
        aWinner(awinner, timeout) {
            setTimeout(() => {
                this.inQuestion = false;
                this.firework = true;
                this.awinner = awinner;
            }, timeout); // Wait milliseconds
        },
        goodAnswer() {
            if (this.answerer >= 0 && !this.scored) {
                this.contestants[this.answerer].score += this.points;
                this.contestants[this.answerer].right += 1;
                this.scored = true;
                if (this.contestants[this.answerer].score >= this.winner) {
                    this.aWinner(this.answerer, 2000);
                    // Wait a few seconds?
                }
            }
        },
        setupPusher() {
            let pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
                cluster: 'us3',
                forceTLS: true
            });
            this.pusher = pusher;
            this.channel = pusher.subscribe("gameshow");
            this.channel.bind("event_" + this.nexmo.userid, data => {
                console.log("Got a gameShow event, data: " + JSON.stringify(data));
                switch (data.event) {
                    case 'enrolled':
                        this.contestants[data.user].enrolled = parseInt(data.enrolled);
                        break;
                    case 'name':
                        this.contestants[data.user].name = data.name;
                        break;
                    case 'identified':
                        if (this.inQuestion && !this.scored) {
                            this.answerer = parseInt(data.contestant);
                            if (this.result) { // We have both!
                                this.goodAnswer();
                            }
                        }
                        break;
                    case 'answered':
                        if (data.correct) {
                            this.result = '<h5>You answered: ' + data.answered + '</h5><h4 style="color:green">The correct answer is: ' + data.answer + '</h4>';
                            //                            this.answerer = data.id;
                            if (this.answerer >= 0) { // We have both!
                                this.goodAnswer();
                            }
                        } else { }
                        break;
                    case 'transcript':
                        if (this.inQuestion) {
                            this.answers.unshift(data.text);
                        } else if (this.contestants[data.user].enrolled < 101) {
                            this.contestants[data.user].text.push(data.text);
                        }
                        break;
                    case 'status':
                        this.connecting = false;
                        if (data.type == 'connected') {
                            this.connected = true;
                            this.$swal({
                                title: '<h4 style="color:green" >Connected!</h4>',
                                showCloseButton: true,
                                html: '<h4>We now need to register the contestants.</h4><h5>For each contestant, click Register, say "<b>Hello, my name is </b><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>", then tell us your position with Vonage, how long you have been with the company, and one interesting thing about yourself. Continue talking until the gauge shows your voice as registered.</h5>',
                                icon: 'success'
                            });
                        }
                        if (data.type == 'disconnected') {
                            this.connected = false;
                        }
                        break;
                    default:
                        break;
                }
            });
        },
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-modal": VltModal,
        "json-view": JSONView,
        VueSpeedometer,
        Firework,
        questions,
    },
    beforeDestroy() {
        console.log("beforeDestroy for gameshow")
        if (this.connected) {
            this.disconnect();
        }
        if (this.pusher) {
            this.pusher.unsubscribe("gameshow");
        }
    },
    created() {
        // If the backend is a NODE server, use this...
        if (process.env.NODE_ENV === 'development') {
            this.dev = true;
        }
        var postscript = "/gameshow";
        if ($NODEBASE.indexOf('ngrok') > 0) {
            postscript = '';
        };
        var url = $NODEBASE + postscript;
        this.DEMO = axios.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json'
            }
        })
        this.DEMO.interceptors.request.use(
            request => requestHandler(request)
        )
        this.register();
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['from']).formatInternational();
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.onUpdate({
            isValid: true,
            formatInternational: this.nexmo['phone'],
            formattedNumber: this.nexmo['phone'],
            countryCode: this.nexmo['region'],
        });
        console.log(this.nexmo);
    },
}
</script>

<style lang="scss" scoped>
div.centered {
    display: flex;
    align-items: center;
    justify-content: center;
}

.glowbutton {
    background-color: #004a7f;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    border: none;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-family: Arial;
    font-size: 20px;
    padding: 5px 10px;
    text-align: center;
    text-decoration: none;
    -webkit-animation: glowing 1500ms infinite;
    -moz-animation: glowing 1500ms infinite;
    -o-animation: glowing 1500ms infinite;
    animation: glowing 1500ms infinite;
}

@-webkit-keyframes glowing {
    0% {
        background-color: #00b200;
        -webkit-box-shadow: 0 0 3px #00b000;
    }

    50% {
        background-color: #00ff00;
        -webkit-box-shadow: 0 0 40px #00ff00;
    }

    100% {
        background-color: #00b20000;
        -webkit-box-shadow: 0 0 3px #00b200;
    }
}

@-moz-keyframes glowing {
    0% {
        background-color: #00b200;
        -moz-box-shadow: 0 0 3px #00b200;
    }

    50% {
        background-color: #00ff00;
        -moz-box-shadow: 0 0 40px #00ff00;
    }

    100% {
        background-color: #00b200;
        -moz-box-shadow: 0 0 3px #00b200;
    }
}

@-o-keyframes glowing {
    0% {
        background-color: #00b200;
        box-shadow: 0 0 3px #00b200;
    }

    50% {
        background-color: #00ff00;
        box-shadow: 0 0 40px #00ff00;
    }

    100% {
        background-color: #00b200;
        box-shadow: 0 0 3px #00b200;
    }
}

@keyframes glowing {
    0% {
        background-color: #00b200;
        box-shadow: 0 0 3px #00b200;
    }

    50% {
        background-color: #00ff00;
        box-shadow: 0 0 40px #00ff00;
    }

    100% {
        background-color: #00b200;
        box-shadow: 0 0 3px #00b200;
    }
}

m1 {
    animation: glow 10s ease-in-out infinite;

    /* For less laggy effect, uncomment this:
  
  animation:none;
  -webkit-text-stroke:1px #fff; 
  
=========== */
}

* {
    box-sizing: border-box;
}

body {
    background: white;
    overflow: hidden;
    text-align: center;
}

figure {
    animation: wobble 5s ease-in-out infinite;
    transform-origin: center center;
    transform-style: preserve-3d;
}

@keyframes wobble {

    0%,
    100% {
        transform: rotate3d(1, 1, 0, 40deg);
    }

    25% {
        transform: rotate3d(-1, 1, 0, 40deg);
    }

    50% {
        transform: rotate3d(-1, -1, 0, 40deg);
    }

    75% {
        transform: rotate3d(1, -1, 0, 40deg);
    }
}

m1 {
    display: block;
    width: 100%;
    padding: 0px;
    line-height: 1.5;
    font: 900 3em "Concert One", sans-serif;
    text-transform: uppercase;
    position: absolute;
    //    margin-left:-60px;
    color: #0a0a0a;
}

@keyframes glow {

    0%,
    100% {
        text-shadow: 0 0 30px red;
    }

    25% {
        text-shadow: 0 0 30px orange;
    }

    50% {
        text-shadow: 0 0 30px forestgreen;
    }

    75% {
        text-shadow: 0 0 30px cyan;
    }
}

m1:nth-child(2) {
    transform: translateZ(5px);
}

m1:nth-child(3) {
    transform: translateZ(10px);
}

m1:nth-child(4) {
    transform: translateZ(15px);
}

m1:nth-child(5) {
    transform: translateZ(20px);
}

m1:nth-child(6) {
    transform: translateZ(25px);
}

m1:nth-child(7) {
    transform: translateZ(30px);
}

m1:nth-child(8) {
    transform: translateZ(35px);
}

m1:nth-child(9) {
    transform: translateZ(40px);
}

m1:nth-child(10) {
    transform: translateZ(45px);
}

.winner {
    position: absolute;
    color: blue;
    display: inline-block;
    font-size: 4.1rem;
    padding: 0;
    white-space: nowrap;
    font-family: "Pacifico", cursive;
    text-shadow: 0 0 1px #fff, 0 0 2px #fff, 0 0 6px #292736, 0 0 8px #292736,
        0 0 10px #292736, 0 0 12px #292736, 0 0 14px #292736;
    animation: glow1 0.59s infinite alternate;
    margin-left: -50px;
}

/* Animation as suggested by Ismail Ghallou */
@keyframes glow1 {
    to {
        text-shadow: 0 0 4px #fff, 0 0 8px #fff, 0 0 12px #d25ed4, 0 0 16px #d25ed4,
            0 0 20px #d25ed4, 0 0 24px #d25ed4, 0 0 28px #d25ed4;
    }
}

.winner {
    text-shadow: 0 0 1px #fff, 0 0 2px #fff, 0 0 6px #292736, 0 0 8px #292736,
        0 0 10px #292736, 0 0 12px #292736, 0 0 14px #292736;
    animation: glow1 0.59s infinite alternate;
}
</style>
